// Cotas simbólicas da vaquinha não têm foto de produto — em vez do ícone 🎁,
// usamos uma ilustração que cresce conforme o valor sobe (semente → árvore).
// As artes ficam em public/vaquinha/cota-01.webp … cota-10.webp.

const VALOR_TIERS = [20, 30, 50, 75, 100, 150, 200, 300, 500, 1000];

/** True quando o presente é uma cota simbólica de contribuição (template vaquinha). */
export const isCotaContribuicao = (categoria?: string | null): boolean =>
  (categoria || '').trim().toLowerCase() === 'contribuição';

/** Caminho da ilustração simbólica correspondente ao valor da cota. */
export const getCotaSimbolicaImagem = (valor?: number | null): string => {
  const v = typeof valor === 'number' && valor > 0 ? valor : VALOR_TIERS[0];
  let idx = VALOR_TIERS.findIndex((tier) => v <= tier);
  if (idx === -1) idx = VALOR_TIERS.length - 1;
  return `/vaquinha/cota-${String(idx + 1).padStart(2, '0')}.webp`;
};
